import { isEmpty } from 'lodash/fp';
import React from 'react';

import { useDevice, useSpace } from '@portals/api/organizations';
import {
  DeviceLocationWidget,
  DeviceLocationWidgetFormType,
} from '@portals/device-widgets';
import { useGetLocation } from '@portals/utils';

import { WidgetProps } from '../device-widgets.types';

export function DeviceLocationWidgetWrapper({
  widget,
  deviceId,

  isDeviceOffline,
  lastUpdateTimestamp,
}: WidgetProps<DeviceLocationWidgetFormType>) {
  const fields = widget?.config?.fields;

  const { color, show_location_name } = fields ?? {};

  const device = useDevice(deviceId);
  const space = useSpace(device.data?.space_id);
  const deviceLocation = useGetLocation(space);

  const getCoordinates = () => {
    if (!device.data) return null;

    if (device.data.state?.lat && device.data.state?.lng) {
      return {
        lat: device.data.state.lat as number,
        lng: device.data.state.lng as number,
      };
    } else if (isEmpty(space.config.location)) {
      return null;
    } else {
      return deviceLocation;
    }
  };

  return (
    <DeviceLocationWidget
      title={space.tree_path_name}
      color={color}
      coordinates={getCoordinates()}
      showLocationName={show_location_name}
      isDeviceOffline={isDeviceOffline}
      lastUpdateTimestamp={lastUpdateTimestamp}
    />
  );
}
